import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningLowYellow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M460.8 716.8c0-28.278 22.923-51.2 51.2-51.2s51.2 22.922 51.2 51.2c0 28.278-22.922 51.2-51.2 51.2s-51.2-22.922-51.2-51.2zM460.8 307.2c0-28.277 22.923-51.2 51.2-51.2s51.2 22.923 51.2 51.2v204.8c0 28.278-22.922 51.2-51.2 51.2s-51.2-22.922-51.2-51.2v-204.8zM511.488 0c-282.624 0-511.488 229.376-511.488 512s228.864 512 511.488 512c283.136 0 512.512-229.376 512.512-512s-229.376-512-512.512-512zM512 921.6c-226.304 0-409.6-183.296-409.6-409.6s183.296-409.6 409.6-409.6c226.304 0 409.6 183.296 409.6 409.6s-183.296 409.6-409.6 409.6z",
		fill: "rgb(242, 201, 76)"
	})
});
const ForwardRef = forwardRef(SvgWarningLowYellow);
export default ForwardRef;
